import React, { useCallback, useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import auth from '../../../firebase-config'
import { signOut } from 'firebase/auth'
import Search from '../../Trainer/Dashboard/Search/Search'
import './index.scss'
import { useContext } from 'react'
import profileRoutes from '../../Profile/profileRoutes'
import AppContext from '../../../store/context'
import { Icon } from '@iconify/react'
import { isAdmin } from '../../../store/baseUrl'
// import { BsChatText } from 'react-icons/bs'
// import ChatBox from '../../ChatFeature/ChatBox'
// import ChatBoxModal from '../../ChatFeature/ChatBoxModal'
import axios from '../../../store/axios-secure'
const AddExercise = React.lazy(() =>
    import('../../Profile/Components/AddExercise'),
)
const PaymentsPage = React.lazy(() =>
    import('../../../components/Profile/Components/Payments'),
)

const AdminPage = React.lazy(() => import('../../Profile/Components/Admin'))
const Navbar = () => {
    const [showShadowClass, setShowShadowClass] = useState('')
    const location = useLocation()
    const history = useHistory()
    const userContext = useContext(AppContext)
    // const [showChatBoxModal, setShowChatBoxModal] = useState(false)
    // const trainerUid = auth?.currentUser?.uid
    // const [contacts, setContacts] = useState([])
    // const [clients, setClients] = useState([])
    useEffect(() => {
        if (isAdmin(auth.currentUser.email)) {
            // if (
            //     profileRoutes.filter((obj) => obj.path === 'payments').length ==
            //     0
            // ) {
            //     profileRoutes.push({
            //         path: 'payments',
            //         exact: true,
            //         component: PaymentsPage,
            //         name: 'Payments',
            //         icon: 'bi-wallet-fill',
            //     })
            // }
            if (
                profileRoutes.filter((obj) => obj.path === 'admin').length == 0
            ) {
                profileRoutes.push({
                    path: 'admin',
                    exact: true,
                    component: AdminPage,
                    name: 'Admin',
                    icon: 'clarity:administrator-solid',
                })
            }
        }
    }, [])
    const logout = () => {
        signOut(auth)
        userContext.setProfileRef(null)
        history.push('/')
    }
    // TODO @rt Find a better method. To Many rerenders
    const handleUserKeyPress = useCallback(() => {
        var scrolled = document.scrollingElement.scrollTop
        if (scrolled >= 10) {
            // TODO remove if not needed
            // setShowShadowClass('scrolled')
        } else {
            setShowShadowClass('')
        }
    }, [])

    useEffect(() => {
        window.addEventListener('scroll', handleUserKeyPress)

        return () => {
            window.removeEventListener('scroll', handleUserKeyPress)
        }
    }, [handleUserKeyPress])

    // const onChatClicked = async () => {
    //     try {
    //         const response = await axios.get('/chat/getChatsAndClients')
    //         setClients(response.data?.clients)
    //         setContacts(response.data?.chats)
    //         //    let clients = response.data?.clients;
    //         //     contacts = response.data?.chats;
    //         //     console.log("chats..........\\", chats)
    //         //     console.log("clients..........\\", clients)
    //     } catch (error) {
    //         console.log('error onChatClicked', error)
    //     }
    //     setShowChatBoxModal(!showChatBoxModal)
    // }
    return (
        <>
            {auth.currentUser ? (
                <>
                    <div
                        className={`navbar sticky-top store-navbar ${showShadowClass}`}
                    >
                        <div className="logoContainer">
                            <Link
                                className="navbar-brand"
                                to={
                                    userContext.profileRef
                                        ? '/'
                                        : '/trainer-onboarding'
                                }
                            >
                                <img
                                    src="/images/evolvfitwhite.svg"
                                    alt="Evolv Fit"
                                    className="navbar-evolv-logo"
                                    width="48px"
                                    height="40px"
                                />
                                <h3>
                                    EVOLV
                                    <br />
                                    <span>FIT</span>
                                </h3>
                            </Link>
                        </div>

                        {location.pathname == '/' && userContext.verified ? (
                            <Search />
                        ) : (
                            ''
                        )}
                        <div className="navbar-right-content">
                            <div
                                className="profile-dropdown-right-content"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}
                            >
                                {/* <BsChatText
                                    onClick={() => onChatClicked()}
                                    style={{
                                        fontSize: '53px',
                                        marginRight: '25px',
                                        cursor: 'pointer',
                                        color: 'white',
                                    }}
                                /> */}
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant="none"
                                        id="dropdown-basic"
                                        className="dropdown-toggle"
                                    >
                                        <img
                                            src={auth?.currentUser?.photoURL}
                                            //alt="Profile"
                                            className="profile-icon"
                                        />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-container">
                                        {userContext.verified ? (
                                            <>
                                                {profileRoutes.map(
                                                    (item, idx) => (
                                                        <Dropdown.Item
                                                            key={idx}
                                                            className="custom-dropdown-item"
                                                            as={Link}
                                                            to={`/profile/${item.path}`}
                                                        >
                                                            <div className="dropdown-item-container">
                                                                <Icon
                                                                    height={43}
                                                                    color="white"
                                                                    icon={
                                                                        item.icon
                                                                    }
                                                                />
                                                                <p>
                                                                    {item.name}
                                                                </p>
                                                            </div>
                                                        </Dropdown.Item>
                                                    ),
                                                )}
                                            </>
                                        ) : null}

                                        <button
                                            className="logout-button"
                                            onClick={logout}
                                        >
                                            {'Log out'}
                                        </button>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>

                    {/* {showChatBoxModal && (
                        <ChatBoxModal
                            clients={clients}
                            contacts={contacts}
                            setClients={setClients}
                            setContacts={setContacts}
                            isOpen={showChatBoxModal}
                            onClose={() => setShowChatBoxModal(false)}
                        />
                    )} */}
                </>
            ) : null}
        </>
    )
}

export default Navbar
